'use-strict';

const { normalizeReverse0100 } = require('../utils/math');
const QuestionProtocol = require('./question-protocol');
const config = require('../data/emotional-config.json');

module.exports = new QuestionProtocol((_evaluation, _tester, answerScore) => {
    return normalizeReverse0100(answerScore, 14, 56);
}, config.questions);